import React from 'react';
import { TRACKS } from '../data/curriculum';

const GOLD = '#C8A84B';
const GOLD_BORDER = 'rgba(200,168,75,0.25)';

const S = {
  page: { maxWidth:680, margin:'0 auto', padding:'36px 20px 100px', fontFamily:"'DM Sans','Segoe UI',sans-serif" },
  headerWrap: { marginBottom:32, textAlign:'center' },
  eyebrow: { fontSize:10, fontWeight:700, letterSpacing:'3px', color:GOLD, fontFamily:"'Cinzel',serif", marginBottom:8, textTransform:'uppercase' },
  title: { fontSize:'clamp(26px,5vw,40px)', fontWeight:800, letterSpacing:'0.04em', color:"#1A1408", lineHeight:1.15, marginBottom:8, fontFamily:"'Cinzel',serif" },
  titleAccent: { color:GOLD },
  sub: { fontSize:17, color:'rgba(26,20,8,0.45)', fontStyle:'italic', fontFamily:"'Cormorant Garamond',Georgia,serif" },
  barSection: { marginBottom:32 },
  barWrap: { height:3, background:'rgba(200,168,75,0.1)', borderRadius:99, overflow:'hidden', marginBottom:6 },
  bar: (pct) => ({ height:'100%', width:pct+'%', background:'linear-gradient(90deg,#C8A84B,#D4B85A)', borderRadius:99, transition:'width 0.8s ease' }),
  barLabel: { fontSize:10, color:'rgba(200,168,75,0.5)', letterSpacing:'1px', textAlign:'right', fontFamily:"'Cinzel',serif" },
  coachCard: { display:'flex', alignItems:'center', justifyContent:'space-between', background:'rgba(200,168,75,0.04)', border:'1px solid rgba(200,168,75,0.25)', borderRadius:14, padding:'16px 20px', marginBottom:36, cursor:'pointer', transition:'all 0.2s' },
  coachLeft: { display:'flex', alignItems:'center', gap:12 },
  coachDot: { width:10, height:10, borderRadius:'50%', background:GOLD, boxShadow:'0 0 8px rgba(200,168,75,0.5)' },
  coachTitle: { fontWeight:700, fontSize:15, color:"#1A1408", fontFamily:"'Cinzel',serif", letterSpacing:'0.04em' },
  coachSub: { fontSize:12, color:'rgba(200,168,75,0.6)', marginTop:3, fontStyle:'italic', fontFamily:"'Cormorant Garamond',Georgia,serif" },
  coachArrow: { fontSize:20, color:GOLD },
  rule: { height:1, background:'linear-gradient(to right,transparent,rgba(200,168,75,0.25),transparent)', marginBottom:20 },
  sectionLabel: { fontSize:9, fontWeight:700, letterSpacing:'3px', color:'rgba(200,168,75,0.4)', marginBottom:16, fontFamily:"'Cinzel',serif", textTransform:'uppercase' },
  modules: { display:'flex', flexDirection:'column', gap:12 },
  module: (done) => ({ background: done ? 'rgba(200,168,75,0.06)' : 'rgba(26,20,8,0.02)', border:'1px solid ' + (done ? 'rgba(200,168,75,0.25)' : 'rgba(26,20,8,0.06)'), borderRadius:14, padding:'18px 20px', cursor:'pointer', transition:'all 0.2s' }),
  moduleTop: { display:'flex', alignItems:'center', gap:10, marginBottom:8 },
  moduleEmoji: { fontSize:22 },
  moduleNum: { fontSize:9, fontWeight:700, letterSpacing:'2px', color:GOLD, fontFamily:"'Cinzel',serif", background:'rgba(200,168,75,0.1)', border:'1px solid rgba(200,168,75,0.2)', padding:'2px 8px', borderRadius:20 },
  moduleDone: { marginLeft:'auto', fontSize:9, fontWeight:700, color:'#4ade80', letterSpacing:'1px', background:'rgba(74,222,128,0.08)', border:'1px solid rgba(74,222,128,0.25)', padding:'2px 8px', borderRadius:20, fontFamily:"'Cinzel',serif" },
  moduleTitle: { fontSize:16, fontWeight:700, color:"#1A1408", marginBottom:4, lineHeight:1.3, fontFamily:"'Cinzel',serif", letterSpacing:'0.02em' },
  moduleSub: { fontSize:13, color:'rgba(26,20,8,0.4)', marginBottom:12, lineHeight:1.5, fontFamily:"'Cormorant Garamond',Georgia,serif", fontStyle:'italic' },
  moduleFooter: { display:'flex', alignItems:'center', justifyContent:'space-between' },
  moduleMeta: { fontSize:11, color:'rgba(200,168,75,0.4)', fontFamily:"'Cinzel',serif", letterSpacing:'0.5px' },
  moduleProgress: { display:'flex', alignItems:'center', gap:8 },
  miniBar: { width:56, height:2, background:'rgba(200,168,75,0.1)', borderRadius:99, overflow:'hidden' },
  miniFill: (pct, color) => ({ height:'100%', width:pct+'%', background:color, borderRadius:99 }),
  moduleCta: (color) => ({ fontSize:12, fontWeight:700, color, fontFamily:"'Cinzel',serif", letterSpacing:'0.5px' }),
  footerNote: { textAlign:'center', marginTop:48, fontSize:10, color:'rgba(200,168,75,0.25)', fontFamily:"'Cinzel',serif", letterSpacing:'1px' },
};

export default function Home({ onStartLesson, onOpenCoach, completedLessons }) {
  const totalLessons = TRACKS.reduce((a, t) => a + t.lessons.length, 0);
  const pct = Math.round((completedLessons.length / totalLessons) * 100);
  const openClaude = () => window.open('https://claude.ai', '_blank');

  return (
    <div style={S.page}>
      <div style={S.headerWrap}>
        <div style={S.eyebrow}>Certified AI Consultant Program</div>
        <h1 style={S.title}><span style={S.titleAccent}>ARIA</span> Academy</h1>
        <p style={S.sub}>Join with your idea. Graduate with it done.</p>
      </div>
      <div style={S.barSection}>
        <div style={S.barWrap}><div style={S.bar(pct)} /></div>
        <div style={S.barLabel}>{completedLessons.length} of {totalLessons} lessons complete · {pct}%</div>
      </div>
      <div style={S.coachCard} onClick={openClaude}>
        <div style={S.coachLeft}>
          <div style={S.coachDot} />
          <div>
            <div style={S.coachTitle}>Talk to ARIA — Your AI Coach</div>
            <div style={S.coachSub}>Opens Claude · Available 24/7 · Powered by Anthropic</div>
          </div>
        </div>
        <div style={S.coachArrow}>→</div>
      </div>
      <div style={S.rule} />
      <div style={S.sectionLabel}>Your Modules</div>
      <div style={S.modules}>
        {TRACKS.map((track, idx) => {
          const doneLessons = track.lessons.filter(l => completedLessons.includes(l.id)).length;
          const trackPct = Math.round((doneLessons / track.lessons.length) * 100);
          const allDone = doneLessons === track.lessons.length;
          return (
            <div key={track.id} style={S.module(allDone)} onClick={() => onStartLesson(track.lessons[0], track)}>
              <div style={S.moduleTop}>
                <span style={S.moduleEmoji}>{track.emoji}</span>
                <span style={S.moduleNum}>Module {idx + 1}</span>
                {allDone && <span style={S.moduleDone}>Complete</span>}
              </div>
              <div style={S.moduleTitle}>{track.title.replace(/^Module \d+ — /, '')}</div>
              <div style={S.moduleSub}>{track.subtitle}</div>
              <div style={S.moduleFooter}>
                <span style={S.moduleMeta}>{doneLessons}/{track.lessons.length} lessons · {track.outcome}</span>
                <div style={S.moduleProgress}>
                  <div style={S.miniBar}><div style={S.miniFill(trackPct, track.color)} /></div>
                  {!allDone && <span style={S.moduleCta(track.color)}>Start →</span>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div style={{background:'rgba(200,168,75,0.06)',border:'1px solid rgba(200,168,75,0.25)',borderRadius:14,padding:'18px 20px',marginTop:12,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'space-between'}} onClick={()=>window.open('https://drive.google.com/drive/folders/13dQIi86eYCOW_gjCTOTeVI1-w-a00X8w?usp=sharing','_blank')}>
        <div>
          <div style={{fontSize:9,fontWeight:700,letterSpacing:'2px',color:'#C8A84B',fontFamily:"'Cinzel',serif",marginBottom:6,textTransform:'uppercase'}}>Reference Library</div>
          <div style={{fontSize:16,fontWeight:700,color:'#1A1408',fontFamily:"'Cinzel',serif",marginBottom:4}}>Resources and Templates</div>
          <div style={{fontSize:13,color:'rgba(74,58,30,0.6)',fontFamily:"'Cormorant Garamond',Georgia,serif",fontStyle:'italic'}}>Companion prompt · PAM cards · Discovery bank · Pricing guide · Portfolio checklist</div>
        </div>
        <div style={{fontSize:20,color:'#C8A84B'}}>→</div>
      </div>
      <div style={S.footerNote}>ARIA — Artificial Intelligence Resource and Instruction Academy · ariaaiacademy.com</div>
    </div>
  );
}
